/**
 * Abholdatum statt Wochentag fuer die Brot-Vorbestellung.
 *
 * Das Produkt bleibt unveraendert: die Option "Abholtag am naechsten" behaelt
 * ihre Werte (Dienstag ... Freitag), es aendert sich nur die Beschriftung im
 * Dropdown auf ein konkretes Datum. Shopify findet die Variante weiterhin ueber
 * den Wert, das exakte Datum reist als Line-Item-Property mit.
 *
 * Reihenfolge der Auswahl - bewusst anders als die Optionsreihenfolge im
 * Produkt:
 *
 *     1. Abholdatum   alle Termine, an denen irgendwo gebacken wird
 *     2. Standort     nur die, die an diesem Datum backen; OHNE Vorauswahl
 *     3. Brot         vor der Standortwahl alle zum Stoebern, danach nur das,
 *                     was dort an dem Tag im Backplan steht
 *
 * Der Standort ist absichtlich leer vorbelegt. Solange er nicht gewaehlt ist,
 * bleibt das Formular gesperrt - sonst landet der Kunde ueber die
 * Vorauswahl in einer Filiale, die er nie bestaetigt hat.
 *
 * Welche Brote es an welchem Tag gibt, steht ausschliesslich im Backplan
 * (snippets/brote-backplan.liquid, gepflegt aus backplan.json im Projektordner).
 * Diese Datei enthaelt bewusst keine Brot- oder Standortnamen.
 */
(function () {
  'use strict';

  // Die deutschen Wochentage sind kanonische Datenwerte. Sie entsprechen den
  // Shopify-Varianten und den Schluesseln in backplan.json und werden auch auf
  // der englischen Storefront niemals fuer Vergleiche uebersetzt.
  var WOCHENTAG = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  var SPRACHEN = {
    de: {
      kurz: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      ortPlatzhalter: 'Bitte Standort wählen',
      keineTermine: 'Derzeit sind keine Abholtermine hinterlegt.',
      unvollstaendig: 'Bitte Abholdatum und Standort wählen.',
      ausverkauft: 'ausverkauft',
      eigenschaftDatum: 'Abholdatum',
      zutaten: 'Zutaten',
      allergene: 'Allergene',
    },
    en: {
      kurz: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      ortPlatzhalter: 'Please select a location',
      keineTermine: 'There are currently no pickup dates available.',
      unvollstaendig: 'Please select a pickup date and location.',
      ausverkauft: 'sold out',
      eigenschaftDatum: 'Pickup date',
      zutaten: 'Ingredients',
      allergene: 'Allergens',
    },
  };

  var STANDARD_BROT = 'Clássico Klein';

  // Quelle: Produkte_Website.xlsx, Stand 2026-08-31. Die Schluessel bleiben
  // die kanonischen deutschen Shopify-Optionswerte, auch auf /en/.
  var BROT_INFOS = {
    de: {
      'Clássico Klein': { zutaten: 'Weizen, Weizenvollkorn, Weizensauerteig, Salz', allergene: 'Gluten (Weizen)' },
      'Clássico Groß': { zutaten: 'Weizen, Weizenvollkorn, Weizensauerteig, Salz', allergene: 'Gluten (Weizen)' },
      'Clássico': { zutaten: 'Weizen, Weizenvollkorn, Weizensauerteig, Salz', allergene: 'Gluten (Weizen)' },
      'Rústico': { zutaten: 'Dinkel, Roggenvollkorn, Dinkelsauerteig, Salz', allergene: 'Gluten (Dinkel, Roggen)' },
      'Porridge Brot': { zutaten: 'Weizen, Weizenvollkorn, Weizensauerteig, Salz, Hafer', allergene: 'Gluten (Weizen, Hafer)' },
      'Sesam': { zutaten: 'Weizen, Weizenvollkorn, Weizensauerteig, Salz, Sesam', allergene: 'Gluten (Weizen), Sesam' },
      'Wallnuss Feige': { zutaten: 'Weizen, Weizenvollkorn, Weizensauerteig, Salz, Walnuss, Feige', allergene: 'Gluten (Weizen), Schalenfrüchte (Walnuss), Sulfite (Spuren, Trockenfeigen)' },
      'Feigen Wallnuss': { zutaten: 'Weizen, Weizenvollkorn, Weizensauerteig, Salz, Walnuss, Feige', allergene: 'Gluten (Weizen), Schalenfrüchte (Walnuss), Sulfite (Spuren, Trockenfeigen)' },
      'NOIR S': { zutaten: 'Weizen, Weizenvollkorn, Weizensauerteig, Salz, Sellerie, gesüßte Sauerkirschen', allergene: 'Gluten (Weizen), Sellerie, Sulfite (Spuren, gesüßte Sauerkirschen)' },
      'Roggenbox': { zutaten: 'Roggenvollkorn, Roggensauerteig, Brotgewürz, Salz', allergene: 'Gluten (Roggen)' },
      'Baguette': { zutaten: 'Weizen, Weizenvollkorn, Hefe, Ackerbohnen, Weizensauerteig, Salz', allergene: 'Gluten (Weizen)' },
      'Saaten Vollkorn': { zutaten: 'Dinkelvollkorn, Roggenvollkorn, Roggensauerteig, verschiedene Saaten, Salz', allergene: 'Gluten (Dinkel, Roggen), Sesam (je nach Saatenmischung)' },
      'Dinkelkasten': { zutaten: 'Dinkelvollkorn, Dinkel, Dinkelsauerteig, Salz', allergene: 'Gluten (Dinkel)' },
    },
    en: {
      'Clássico Klein': { zutaten: 'wheat, wholegrain wheat, wheat sourdough, salt', allergene: 'gluten (wheat)' },
      'Clássico Groß': { zutaten: 'wheat, wholegrain wheat, wheat sourdough, salt', allergene: 'gluten (wheat)' },
      'Clássico': { zutaten: 'wheat, wholegrain wheat, wheat sourdough, salt', allergene: 'gluten (wheat)' },
      'Rústico': { zutaten: 'spelt, wholegrain rye, spelt sourdough, salt', allergene: 'gluten (spelt, rye)' },
      'Porridge Brot': { zutaten: 'wheat, wholegrain wheat, wheat sourdough, salt, oats', allergene: 'gluten (wheat, oats)' },
      'Sesam': { zutaten: 'wheat, wholegrain wheat, wheat sourdough, salt, sesame', allergene: 'gluten (wheat), sesame' },
      'Wallnuss Feige': { zutaten: 'wheat, wholegrain wheat, wheat sourdough, salt, walnut, fig', allergene: 'gluten (wheat), tree nuts (walnut), sulphites (traces, dried figs)' },
      'Feigen Wallnuss': { zutaten: 'wheat, wholegrain wheat, wheat sourdough, salt, walnut, fig', allergene: 'gluten (wheat), tree nuts (walnut), sulphites (traces, dried figs)' },
      'NOIR S': { zutaten: 'wheat, wholegrain wheat, wheat sourdough, salt, celery, sweetened sour cherries', allergene: 'gluten (wheat), celery, sulphites (traces, sweetened sour cherries)' },
      'Roggenbox': { zutaten: 'wholegrain rye, rye sourdough, bread spices, salt', allergene: 'gluten (rye)' },
      'Baguette': { zutaten: 'wheat, wholegrain wheat, yeast, field beans, wheat sourdough, salt', allergene: 'gluten (wheat)' },
      'Saaten Vollkorn': { zutaten: 'wholegrain spelt, wholegrain rye, rye sourdough, assorted seeds, salt', allergene: 'gluten (spelt, rye), sesame (depending on the seed mix)' },
      'Dinkelkasten': { zutaten: 'wholegrain spelt, spelt, spelt sourdough, salt', allergene: 'gluten (spelt)' },
    },
  };

  // Nur diese Zuordnungen sind anhand der Variantenbilder eindeutig. Fuer
  // alle anderen Sorten wird bewusst kein bestehendes Brotbild wiederverwendet.
  var BROTE_MIT_FOTO = [
    'Clássico Klein',
    'Rústico',
    'Porridge Brot',
    'Dinkelkasten',
    'Wallnuss Feige',
    'Saaten Vollkorn',
    'NOIR S',
    'Clássico',
    'Kardamom Knoten',
    'Feigen Wallnuss',
  ];

  function iso(datum) {
    var m = String(datum.getMonth() + 1).padStart(2, '0');
    var t = String(datum.getDate()).padStart(2, '0');
    return datum.getFullYear() + '-' + m + '-' + t;
  }

  function lesbar(datum, text) {
    var t = String(datum.getDate()).padStart(2, '0');
    var m = String(datum.getMonth() + 1).padStart(2, '0');
    if (text === SPRACHEN.en) {
      return text.kurz[datum.getDay()] + ', ' + t + '/' + m + '/' + datum.getFullYear();
    }
    return text.kurz[datum.getDay()] + ', ' + t + '.' + m + '.' + datum.getFullYear();
  }

  function jsonAus(wurzel, attribut) {
    var el = wurzel.querySelector('[' + attribut + ']');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (fehler) {
      console.error('[brote-datum] ' + attribut + ' ist kein gueltiges JSON:', fehler);
      return null;
    }
  }

  // Immer ueber options[selectedIndex] statt selectedOptions: liefert nach
  // einem Neuaufbau der Liste zuverlaessig die aktuelle Wahl.
  function gewaehlte(sel) {
    return sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
  }

  // Nachbau von Shopifys handleize - die Theme-Logik liest data-handle von
  // der gewaehlten Option (getOptions in island-product).
  function handleize(wert) {
    return String(wert)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function option(wert, beschriftung, daten) {
    var opt = document.createElement('option');
    opt.value = wert;
    opt.textContent = beschriftung;
    opt.dataset.handle = handleize(wert);
    Object.keys(daten || {}).forEach(function (schluessel) {
      opt.dataset[schluessel] = daten[schluessel];
    });
    return opt;
  }

  // Diagnose fuer den manuellen Test: jede Zeile beschreibt einen Schritt,
  // die erste fehlende sagt, wo es klemmt.
  function log() {
    var args = ['[brote-datum]'].concat(Array.prototype.slice.call(arguments));
    console.info.apply(console, args);
  }

  function BroteDatum(wurzel) {
    log('Start, Skriptstand 2026-08-31-H');
    var konfig = jsonAus(wurzel, 'data-brote-backplan');
    var varianten = jsonAus(wurzel, 'data-brote-varianten');
    if (!konfig || !varianten) {
      log('ABBRUCH: Backplan oder Varianten fehlen/unlesbar', {
        backplan: Boolean(konfig),
        varianten: Boolean(varianten),
      });
      return;
    }
    // Backplan pro Produkt: neuer Aufbau hat produkte[handle].standorte,
    // der alte Aufbau ein globales standorte-Objekt.
    var sprache = (wurzel.getAttribute('data-sprache') || 'de').toLowerCase();
    var TEXT = SPRACHEN[sprache] || SPRACHEN.de;
    var handle = wurzel.getAttribute('data-produkt-handle') || '';
    var produktId = wurzel.getAttribute('data-produkt-id') || '';
    var produkte = konfig.produkte || {};
    // product.handle ist auf /en/ uebersetzbar (z. B. our-breads-1) und daher
    // kein stabiler Datenschluessel. Die Produkt-ID bleibt in jeder Sprache
    // identisch; der Handle ist nur noch Rueckwaertskompatibilitaet.
    var produktKonfig = Object.keys(produkte).map(function (produktHandle) {
      return produkte[produktHandle];
    }).find(function (eintrag) {
      return String(eintrag.produkt_id || '') === produktId;
    }) || produkte[handle];
    var standorte = (produktKonfig && produktKonfig.standorte) || konfig.standorte || {};
    var festerOrt = (produktKonfig && produktKonfig.fester_standort) || '';
    if (!Object.keys(standorte).length) {
      log('ABBRUCH: kein Backplan-Abschnitt fuer Produkt', handle);
      return;
    }
    log('Daten gelesen:', handle, '|', Object.keys(standorte).length, 'Standorte,', varianten.length, 'Varianten');

    var selOrt = null;
    var selTag = null;
    var selBrot = null;
    wurzel.querySelectorAll('select[data-single-option-selector]').forEach(function (sel) {
      var pos = sel.getAttribute('data-position');
      if (festerOrt) {
        if (pos === '1') selTag = sel;
        if (pos === '2') selBrot = sel;
      } else {
        if (pos === '1') selOrt = sel;
        if (pos === '2') selTag = sel;
        if (pos === '3') selBrot = sel;
      }
    });
    if ((!festerOrt && !selOrt) || !selTag || !selBrot) {
      log('ABBRUCH: Selects nicht gefunden', {
        standort: Boolean(selOrt),
        abholtag: Boolean(selTag),
        brot: Boolean(selBrot),
      });
      return;
    }
    log('Selects gefunden');

    var alleBrote = Array.prototype.map.call(selBrot.options, function (o) {
      return o.value;
    });

    var verfuegbar = {};
    var brotBilder = {};
    varianten.forEach(function (v) {
      var brotName = festerOrt ? v.o2 : v.o3;
      var variantenSchluessel = festerOrt
        ? v.o1 + ' ' + v.o2
        : v.o1 + ' ' + v.o2 + ' ' + v.o3;
      verfuegbar[variantenSchluessel] = v.verfuegbar;
      if (brotName && v.bild && !brotBilder[brotName]) {
        brotBilder[brotName] = v.bild;
      }
    });

    var hinweis = wurzel.querySelector('[data-brote-hinweis]');
    var form = wurzel.querySelector('form[data-product-form]');
    var brotInfo = wurzel.querySelector('[data-brot-info]');
    var brotInfoName = wurzel.querySelector('[data-brot-info-name]');
    var brotInfoZutaten = wurzel.querySelector('[data-brot-info-zutaten]');
    var brotInfoAllergene = wurzel.querySelector('[data-brot-info-allergene]');
    var brotInfoPlatzhalter = wurzel.querySelector('[data-brot-info-platzhalter]');
    var fotoFolgt = wurzel.querySelector('[data-brot-foto-folgt]');
    var medienSpalte = wurzel.querySelector('.product-media');
    var galerie = medienSpalte ? medienSpalte.firstElementChild : null;

    if (fotoFolgt && medienSpalte) {
      medienSpalte.appendChild(fotoFolgt);
    }
    if (brotInfo && medienSpalte) {
      medienSpalte.appendChild(brotInfo);
    }

    // 1. Datum, 2. Standort, 3. Brot - die Optionsreihenfolge im Produkt ist
    // eine andere. Umsortiert wird NUR visuell per CSS order: die Theme-Logik
    // (getOptions in island-product) liest die Selects in DOM-Reihenfolge und
    // mappt sie positionsweise auf die Varianten-Optionen. Eine echte
    // DOM-Umsortierung wuerde Standort und Abholtag vertauschen - dann passt
    // keine Variante mehr und alles steht auf "Nicht verfuegbar".
    var feldTag = selTag.closest('fieldset');
    var feldOrt = selOrt ? selOrt.closest('fieldset') : null;
    var feldBrot = selBrot.closest('fieldset');
    if (feldTag && feldBrot && feldTag.parentNode && (festerOrt || feldOrt)) {
      var behaelter = feldTag.parentNode;
      behaelter.style.display = 'flex';
      behaelter.style.flexDirection = 'column';
      behaelter.style.gap = '0.625rem';
      [feldOrt, feldTag, feldBrot].filter(Boolean).forEach(function (feld) {
        feld.style.marginTop = '0';
      });
      feldTag.style.order = '1';
      if (feldOrt) feldOrt.style.order = '2';
      feldBrot.style.order = '3';
    }

    function zeichneBrotInfo() {
      if (!brotInfo) return;
      var brot = gewaehlte(selBrot);
      var name = brot && brot.value && !brot.disabled ? brot.value : '';
      brotInfo.hidden = !name;
      if (!name) return;

      if (brotInfoName) brotInfoName.textContent = name;
      var infos = (BROT_INFOS[sprache] || BROT_INFOS.de)[name];
      if (brotInfoZutaten) {
        brotInfoZutaten.hidden = !infos;
        brotInfoZutaten.textContent = infos ? TEXT.zutaten + ': ' + infos.zutaten : '';
      }
      if (brotInfoAllergene) {
        brotInfoAllergene.hidden = !infos;
        brotInfoAllergene.textContent = infos ? TEXT.allergene + ': ' + infos.allergene : '';
      }
      if (brotInfoPlatzhalter) brotInfoPlatzhalter.hidden = Boolean(infos);

      // Ohne Standort gibt es noch keine vollstaendige Shopify-Variante. Die
      // Bild-URL der Brotvariante wird deshalb auf das entsprechende Medium in
      // der vorhandenen Galerie abgebildet, ohne eine Filiale vorzuwaehlen.
      var bild = brotBilder[name];
      var produktWurzel = wurzel.querySelector('[data-product-root]');
      var medienId = medienIdFuerBild(bild);
      var hatFoto = BROTE_MIT_FOTO.indexOf(name) !== -1 && Boolean(medienId);
      if (galerie) galerie.style.display = hatFoto ? '' : 'none';
      if (fotoFolgt) {
        fotoFolgt.hidden = hatFoto;
        fotoFolgt.style.display = hatFoto ? 'none' : 'flex';
      }
      if (hatFoto && produktWurzel) {
        var produktDaten = window.Alpine && window.Alpine.$data
          ? window.Alpine.$data(produktWurzel)
          : null;
        if (produktDaten) {
          produktDaten.currentMediaId = medienId;
        } else {
          produktWurzel.dispatchEvent(new CustomEvent('shapes:product:variantchange', {
            bubbles: true,
            detail: { variant: { featured_media: { id: medienId } } },
          }));
        }
      }
    }

    function bildDatei(url) {
      if (!url) return '';
      try {
        var pfad = new URL(url, window.location.href).pathname;
        return decodeURIComponent(pfad.substring(pfad.lastIndexOf('/') + 1));
      } catch (_) {
        return '';
      }
    }

    function medienIdFuerBild(bild) {
      var datei = bildDatei(bild);
      if (!datei || !medienSpalte) return null;
      var medienId = null;
      Array.prototype.some.call(medienSpalte.querySelectorAll('[data-media-id] img'), function (img) {
        if (bildDatei(img.currentSrc || img.src) !== datei) return false;
        var medium = img.closest('[data-media-id]');
        medienId = medium ? Number(medium.getAttribute('data-media-id')) : null;
        return Boolean(medienId);
      });
      return medienId;
    }

    function eigenschaft(name) {
      if (!form) return null;
      var vorhanden = form.querySelector('input[name="properties[' + name + ']"]');
      if (vorhanden) return vorhanden;
      var neu = document.createElement('input');
      neu.type = 'hidden';
      neu.name = 'properties[' + name + ']';
      form.appendChild(neu);
      return neu;
    }

    function fruehesterTag() {
      var jetzt = new Date();
      var grenze = new Date(jetzt);
      grenze.setHours(konfig.cutoff.stunde, konfig.cutoff.minute, 0, 0);
      var start = new Date(jetzt);
      start.setHours(0, 0, 0, 0);
      // Bestellbar bis zum Cutoff des Vortags: vor der Grenze ist morgen der
      // frueheste Abholtag, danach uebermorgen. Der heutige Tag ist damit nie
      // waehlbar.
      //
      // Bei cutoff.stunde = 24 rollt setHours auf Mitternacht des Folgetags -
      // die Grenze wird also nie ueberschritten und es bleibt durchgehend bei
      // "morgen". Genau das ist die Regel: bis 24 Uhr fuer den naechsten Tag.
      start.setDate(start.getDate() + (jetzt >= grenze ? 2 : 1));
      return start;
    }

    /** Alle Termine, an denen mindestens ein Standort backt. */
    function termine() {
      var gesperrt = konfig.gesperrt || [];
      var liste = [];
      var lauf = fruehesterTag();
      for (var i = 0; i < (konfig.horizont_tage || 21); i++) {
        var name = WOCHENTAG[lauf.getDay()];
        var tag = iso(lauf);
        if (gesperrt.indexOf(tag) === -1) {
          var orte = Object.keys(standorte).filter(function (ort) {
            return Boolean(standorte[ort][name]);
          });
          if (orte.length) {
            liste.push({ iso: tag, wochentag: name, label: lesbar(lauf, TEXT), orte: orte });
          }
        }
        lauf.setDate(lauf.getDate() + 1);
      }
      return liste;
    }

    var termineNachIso = {};

    function zeichneTermine() {
      var vorherOpt = gewaehlte(selTag);
      var vorher = vorherOpt ? vorherOpt.dataset.datum : null;
      var liste = termine();

      termineNachIso = {};
      selTag.innerHTML = '';
      liste.forEach(function (t) {
        termineNachIso[t.iso] = t;
        selTag.appendChild(option(t.wochentag, t.label, { datum: t.iso, wochentag: t.wochentag }));
      });

      selTag.disabled = liste.length === 0;
      if (liste.length === 0) return false;

      var index = 0;
      liste.some(function (t, i) {
        if (t.iso === vorher) {
          index = i;
          return true;
        }
        return false;
      });
      selTag.selectedIndex = index;
      return true;
    }

    function gewaehlterTermin() {
      var opt = gewaehlte(selTag);
      return opt ? termineNachIso[opt.dataset.datum] || null : null;
    }

    var ortInitialisiert = false;

    /** Standorte des gewaehlten Termins - ohne Vorauswahl. */
    function zeichneOrte() {
      if (festerOrt) return;
      var termin = gewaehlterTermin();
      // Beim allerersten Aufbau steht im Select die Server-Vorauswahl (erste
      // Option). Die ist KEINE bewusste Wahl und wird verworfen - sonst gilt
      // das Formular sofort als vollstaendig. Erst ab dem zweiten Aufbau kann
      // der Wert nur von einer echten Nutzerwahl stammen.
      var vorher = ortInitialisiert ? selOrt.value : '';
      ortInitialisiert = true;

      selOrt.innerHTML = '';
      selOrt.appendChild(option('', TEXT.ortPlatzhalter));
      (termin ? termin.orte : []).forEach(function (ort) {
        selOrt.appendChild(option(ort, ort));
      });

      // Eine frueher getroffene Wahl darf bestehen bleiben, solange sie zum
      // neuen Datum passt. Passt sie nicht, faellt sie bewusst auf den
      // Platzhalter zurueck statt still auf eine andere Filiale zu springen.
      var haltbar = vorher && termin && termin.orte.indexOf(vorher) !== -1;
      selOrt.value = haltbar ? vorher : '';
      selOrt.disabled = !termin;
    }

    var brotInitialisiert = false;

    function zeichneBrote() {
      var termin = gewaehlterTermin();
      var ort = festerOrt || selOrt.value;
      var vorher = brotInitialisiert ? selBrot.value : STANDARD_BROT;
      brotInitialisiert = true;

      selBrot.innerHTML = '';

      // Vor der Standortwahl sind alle Sorten zum Stoebern sichtbar. Erst mit
      // einer Filiale wird die Liste auf deren Backplan fuer den Termin
      // eingeschraenkt. Die Kaufsperre bleibt davon getrennt bestehen.
      var erlaubt = termin && ort
        ? (standorte[ort] || {})[termin.wochentag] || []
        : alleBrote;
      alleBrote.forEach(function (brot) {
        if (erlaubt.indexOf(brot) === -1) return;
        var frei = termin && ort
          ? verfuegbar[festerOrt
            ? termin.wochentag + ' ' + brot
            : ort + ' ' + termin.wochentag + ' ' + brot]
          : true;
        var opt = option(brot, frei === false ? brot + ' – ' + TEXT.ausverkauft : brot);
        opt.disabled = frei === false;
        selBrot.appendChild(opt);
      });

      selBrot.disabled = selBrot.options.length === 0;
      if (!selBrot.options.length) {
        zeichneBrotInfo();
        return;
      }

      var treffer = Array.prototype.some.call(selBrot.options, function (o, i) {
        if (o.value === vorher && !o.disabled) {
          selBrot.selectedIndex = i;
          return true;
        }
        return false;
      });
      if (!treffer) {
        var standard = Array.prototype.findIndex.call(selBrot.options, function (o) {
          return o.value === STANDARD_BROT && !o.disabled;
        });
        var ersterFreier = Array.prototype.findIndex.call(selBrot.options, function (o) {
          return !o.disabled;
        });
        selBrot.selectedIndex = standard !== -1 ? standard : (ersterFreier === -1 ? 0 : ersterFreier);
      }
      zeichneBrotInfo();
    }

    function vollstaendig() {
      var termin = gewaehlterTermin();
      var brot = gewaehlte(selBrot);
      return Boolean(termin && (festerOrt || selOrt.value) && brot && brot.value && !brot.disabled);
    }

    /**
     * Solange die Auswahl unvollstaendig ist, muss das Absenden hart blockiert
     * sein: im Formular steht ein verstecktes <select name="id"> mit allen
     * Varianten, das sonst stillschweigend die zuletzt gueltige Variante in den
     * Warenkorb legen wuerde.
     */
    function sperren() {
      var offen = !vollstaendig();
      if (form) {
        form.querySelectorAll('[type="submit"], [name="add"]').forEach(function (knopf) {
          knopf.disabled = offen;
          knopf.setAttribute('aria-disabled', String(offen));
        });
        var express = form.querySelector('.shopify-payment-button');
        if (express) {
          express.style.opacity = offen ? '0.4' : '';
          express.style.pointerEvents = offen ? 'none' : '';
        }
      }
      if (hinweis) {
        var keineTermine = selTag.options.length === 0;
        hinweis.hidden = !offen;
        hinweis.textContent = keineTermine ? TEXT.keineTermine : TEXT.unvollstaendig;
      }
    }

    function schreibeDatum() {
      var termin = gewaehlterTermin();
      var sichtbar = eigenschaft(TEXT.eigenschaftDatum);
      var maschinell = eigenschaft('_Abholdatum_ISO');
      if (sichtbar) sichtbar.value = termin ? gewaehlte(selTag).textContent : '';
      if (maschinell) maschinell.value = termin ? termin.iso : '';
    }

    // Waehrend syncTheme feuert dieses Skript selbst change-Events, auf die es
    // auch selbst lauscht. Ohne diese Sperre entsteht daraus eine Endlos-
    // schleife (melden -> nachTag -> syncTheme -> melden ...), die den
    // Browser-Hauptthread einfriert - exakt der Fehler vom 2026-08-16.
    var intern = false;

    function melden(sel) {
      intern = true;
      try {
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      } finally {
        intern = false;
      }
    }

    /**
     * Dem Theme die aktuelle Auswahl melden - auch eine unvollstaendige.
     *
     * Beschriftung und Sperre des Kaufknopfes gehoeren dem Theme, nicht diesem
     * Skript: der Knopf bindet per Alpine an currentVariantAvailable und
     * addToCartText. Serverseitig steht dort die erste Variante des Produkts,
     * also "Zum Einkaufswagen hinzufuegen - 5,00 EUR" - ein Preis fuer eine
     * Kombination, die der Kunde nie gewaehlt hat.
     *
     * Frueher stieg diese Funktion bei unvollstaendiger Auswahl vorzeitig aus.
     * Damit erfuhr das Theme beim Laden nie etwas und der Text blieb stehen,
     * bis der Kunde zum ersten Mal das Datum wechselte - denn ein echtes
     * change-Event erreicht das Theme ohnehin. Genau dieser eine Fall fehlte.
     * Deshalb wird jetzt immer gemeldet; die intern-Sperre in melden() haelt
     * die Rueckkopplung weiterhin auf.
     */
    function syncTheme() {
      melden(selTag);
      if (selOrt) melden(selOrt);
      melden(selBrot);
    }

    function nachTag() {
      if (intern) return;
      zeichneOrte();
      zeichneBrote();
      schreibeDatum();
      sperren();
      syncTheme();
    }

    function nachOrt() {
      if (intern) return;
      zeichneBrote();
      schreibeDatum();
      sperren();
      syncTheme();
    }

    function nachBrot() {
      if (intern) return;
      zeichneBrotInfo();
      sperren();
      syncTheme();
    }

    selTag.addEventListener('change', nachTag);
    if (selOrt) selOrt.addEventListener('change', nachOrt);
    selBrot.addEventListener('change', nachBrot);

    if (form) {
      form.addEventListener(
        'submit',
        function (ereignis) {
          if (vollstaendig()) return;
          ereignis.preventDefault();
          ereignis.stopImmediatePropagation();
          sperren();
        },
        true
      );
    }

    zeichneTermine();
    zeichneOrte();
    zeichneBrote();
    schreibeDatum();
    sperren();
    log('Aufbau fertig:', selTag.options.length, 'Termine im Dropdown, erster:',
      selTag.options.length ? selTag.options[0].textContent : '(keiner)');

    // Falls das Theme die Selects nach der Hydrierung zuruecksetzt, faellt das
    // hier sofort auf - und wird einmalig repariert statt nur beklagt.
    var waechter = new MutationObserver(function () {
      var erste = selTag.options.length ? selTag.options[0] : null;
      if (erste && !erste.dataset.datum) {
        log('WARNUNG: Termin-Dropdown wurde von aussen zurueckgesetzt - baue neu auf');
        waechter.disconnect();
        zeichneTermine();
        zeichneOrte();
        zeichneBrote();
        schreibeDatum();
        sperren();
      }
    });
    waechter.observe(selTag, { childList: true });

    // Die Insel hydriert verzoegert; erst danach hoert das Theme auf change.
    if (window.Alpine) {
      syncTheme();
    } else {
      document.addEventListener('alpine:initialized', syncTheme, { once: true });
    }
    window.setTimeout(syncTheme, 1200);
  }

  function start() {
    var wurzeln = document.querySelectorAll('[data-brote-vorbestellung]');
    if (!wurzeln.length) {
      console.info('[brote-datum] Skript geladen, aber kein data-brote-vorbestellung im DOM');
      return;
    }
    wurzeln.forEach(function (wurzel) {
      try {
        BroteDatum(wurzel);
      } catch (fehler) {
        console.error('[brote-datum] FEHLER waehrend des Aufbaus:', fehler);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
